var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.2C0 11.22 0.78 12 1.8 12H10.2C11.22 12 12 11.22 12 10.2V5.4H0V10.2ZM10.2 1.2H9V0.6C9 0.24 8.76 0 8.4 0C8.04 0 7.8 0.24 7.8 0.6V1.2H4.2V0.6C4.2 0.24 3.96 0 3.6 0C3.24 0 3 0.24 3 0.6V1.2H1.8C0.78 1.2 0 1.98 0 3V4.2H12V3C12 1.98 11.22 1.2 10.2 1.2Z",
    fill: "#59B974"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.cbdfcb0de2d27cf86fdf65cd04119de5.svg";
export { ForwardRef as ReactComponent };